




































// vue
import { Component, Vue, Watch, Ref, Prop, Model } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";

// types
import { FilterOptions, Filters, ExcludableFilters, EmitFilter, EmitExclude, FilterOption } from "@/types/reports/Filters";

// components
import vselect3 from "vselect3";

@Component({
    components: {
        vselect3
    }
})
export default class SelectFilter extends Vue {
    // ADD TYPE.
    @Prop({ default: () => null, type: Object }) filter: FilterOption;
    @Model('input', { type: Object }) readonly value!: Filters;
    @Prop({ default: false, type: Boolean }) canFilterInternally: boolean;
    @Prop({ default: null, type: Function }) getOptionKey: () => string;

    // Enums 
    private filterOptions: any = FilterOptions;
    private excludableFilters: any = ExcludableFilters;

    private emitExcludeState(excludeState: boolean) {
        const filterEmit: EmitExclude = {
            filterName: this.filter.filterName,
            filterType: this.filter.type,
            state: excludeState
        }
        this.$emit("set-exclude", filterEmit);
    }


    private searchInteral(query: string, loading: any, filterName: string) {
        this.$emit("search", { query, filterName, loading });
    }
}
